'use strict';

angular.module('userRequestEditControllers')

    .controller('MissingAdmAccountController', ['$scope', '$state', 'editAccessRequestService', function ($scope, $state, editAccessRequestService) {

        // On Custom Employee Login Update
        $scope.onCheckAdmUsername = function (employeeAdmLogin, isPropose) {

            isPropose = isPropose || false;
            editAccessRequestService
                .request.checkCorrectAdmAccount($scope.userRequest.UserAccessRequestID, employeeAdmLogin)
                .then(function (isCorrect) {
                    $scope.isCustomUsernameCorrect = isCorrect;

                    if ($scope.isCustomUsernameCorrect
                        && $scope.isCustomUsernameCorrect.IsValid) {
                        $scope.validatedAdmUsername = employeeAdmLogin;
                    } else {
                        $scope.validatedAdmUsername = undefined;
                    }

                    if ($scope.isCustomUsernameCorrect && isPropose) {
                        $scope.selectProposedUsername();
                    }
                    else {
                        $scope.selectCustomUsername();
                    }
                });
        };

        $scope.validatedAdmUsername = undefined;

        // Select Proposed Employee Login Choice
        $scope.selectProposedUsername = function () {
            $scope.isCustomUsernameSelected = false;
        };

        // Select Custom Employee Login
        $scope.selectCustomUsername = function () {
            $scope.isCustomUsernameSelected = true;
        };

        //Confirm ADM Login
        $scope.addAdmAccount = function (customEmployeeAdmLogin) {
            if ($scope.isCustomUsernameSelected && $scope.isCustomUsernameCorrect && $scope.isCustomUsernameCorrect.IsValid) {
                editAccessRequestService
                    .request.addAdmAccountToUserRequest($scope.userRequest.UserAccessRequestID, customEmployeeAdmLogin)
                    .then(function () {
                        $state.reload();
                    });
            }
            else {
                editAccessRequestService
                    .request.addAdmAccountToUserRequest($scope.userRequest.UserAccessRequestID, $scope.proposedAccount.ProposedUsername)
                    .then(function () {
                        $state.reload();
                    });
            }
           
		}

		editAccessRequestService
			.request.getProposedActiveDirectoryAdmAccountUsername($scope.userRequest.UserAccessRequestID)
			.then(function(proposedAccount) {
				$scope.proposedAccount = proposedAccount;
				if ($scope.proposedAccount.AccountNameCustomizable) {
					var isProposed = true;
                    $scope.onCheckAdmUsername($scope.proposedAccount.ProposedUsername, isProposed);
				}
			});
	}]);